import { render, staticRenderFns } from "./CookiesPolicy.vue?vue&type=template&id=4925576e&scoped=true&"
import script from "./CookiesPolicy.vue?vue&type=script&lang=js&"
export * from "./CookiesPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4925576e",
  null
  
)

export default component.exports